var React = require('react');

function IconFacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icon--facebook","fillRule":"evenodd","clipRule":"evenodd","d":"M11 3.47689H7.85774C7.48638 3.47689 7.07146 3.97044 7.07146 4.63067V6.92289H11V10.1896H7.07146V20H3.3627V10.1896H0V6.92289H3.3627V5C3.3627 2.24267 5.25712 0 7.85774 0H11V3.47689Z","fill":"#B8B8B8"}));
}

IconFacebookInline.defaultProps = {"width":"11","height":"20","viewBox":"0 0 11 20","fill":"none"};

module.exports = IconFacebookInline;

IconFacebookInline.default = IconFacebookInline;
